/**
 * Muhasebe kod satirinin BELGE TURU: kodun hangi aktarimin kodu oldugu.
 *
 *   0 satis        (IntegrationAccountCode, IsPurchase = 0)
 *   1 alis         (IntegrationAccountCode, IsPurchase = 1)
 *   2 satis iadesi (IntegrationRefundAccountCode, IsPurchase = 0)
 *   3 alis iadesi  (IntegrationRefundAccountCode, IsPurchase = 1)
 *
 * IKI ekran kullaniyor: secerek aktarim sayfasi (dismuhasebeaktarim.vue) ve
 * eski toplu aktarim sayfasinin Logo kod penceresi (index.vue). Ayni sunucu
 * listesini (MuhasebeKodListesi) okuyorlar; turetme iki yere kopyalansaydi
 * biri iade satirlarini Satis kumesinde gosterir, orada kaydedilen kod da
 * yanlis tabloya giderdi.
 *
 * Iade satirlari listeye YALNIZCA { IadeDahil: true } istegiyle gelir (iki
 * ekran da bunu gonderiyor). Bu modulu tanimayan eski paketler turu yalnizca
 * AlisMi'den ayiriyor; sunucu onlara iade satiri gondermez ki ayni ismin
 * ikinci satiri Satis/Alis kumesinde gorunmesin.
 *
 * ESKI sunucu BelgeTuru gondermiyor: tur o zaman AlisMi'den turetilir (iade
 * kodlari o sunucuda zaten yok). Sunucu sozlesmesi de ayni: BelgeTuru
 * yoksa AlisMi'ye bakiyor.
 */

/** Kod ekranindaki tur dugmesinin degeri -> belge turu. */
export const KOD_TURLERI = { S: 0, A: 1, SI: 2, AI: 3 };

/**
 * Deger gecerli bir belge turu mu (0-3 arasi tam SAYI). Metin "2" kabul
 * edilmez: sunucu int gonderiyor, metin gelmesi bozuk yanit demek.
 */
function GecerliTur(deger) {
  return typeof deger === "number" && Number.isInteger(deger) && deger >= 0 && deger <= 3;
}

/** Tur dugmesinin degerinden belge turu; bilinmeyen deger satis (0). */
export function KodTuruBelgeTuru(kodTur) {
  return Object.prototype.hasOwnProperty.call(KOD_TURLERI, kodTur) ? KOD_TURLERI[kodTur] : 0;
}

/**
 * Kod listesi satirinin (MuhasebeKodSatiri) belge turu: BelgeTuru, yoksa
 * AlisMi'den (alis 1, degilse satis 0).
 */
export function SatirBelgeTuru(satir) {
  if (!satir) return 0;
  return GecerliTur(satir.BelgeTuru) ? satir.BelgeTuru : satir.AlisMi ? 1 : 0;
}

/**
 * Kalem satirinin (FaturaSatirOzeti) kodunun ALINDIGI kombinasyonun belge
 * turu: KodBelgeTuru, yoksa KodAlisMi'den. Satis kalemi 0, alis/maliyet
 * kalemi 1, satis iadesi 2, alis iadesi 3.
 */
export function KalemBelgeTuru(satir) {
  if (!satir) return 0;
  return GecerliTur(satir.KodBelgeTuru) ? satir.KodBelgeTuru : satir.KodAlisMi ? 1 : 0;
}

/** Iade kodu mu (MASTER_CODE alani yalnizca bunlarda var). */
export function IadeTuruMu(belgeTuru) {
  return belgeTuru === 2 || belgeTuru === 3;
}

export default {
  KOD_TURLERI,
  KodTuruBelgeTuru,
  SatirBelgeTuru,
  KalemBelgeTuru,
  IadeTuruMu,
};
